<script lang="ts">
</script>

<section class="applied-filters-wrapper">
  <div class="buttons-wrapper">
    <slot />
  </div>
  {#if $$slots.action}
    <div class="action-wrapper">
      <slot name="action" />
    </div>
  {/if}
</section>

<style type="text/scss" lang="scss" scoped>
  .applied-filters-wrapper {
    @apply hidden;
    @apply md:flex md:justify-between;
    @apply pt-6;
  }
  .buttons-wrapper {
    /* Space between list items */
    --space-x: theme("spacing.6"); /* 24px */
    --space-y: theme("spacing.4"); /* 20px */

    @apply flex flex-wrap;
    /* Trick to re-create flex-gap for browsers that don't support it */
    margin-left: calc(var(--space-x) * -1);
    margin-top: calc(var(--space-y) * -1);
  }

  :global(.buttons-wrapper > *) {
    margin-left: var(--space-x);
    margin-top: var(--space-y);
  }

  .buttons-wrapper + .action-wrapper {
    @apply ml-8;
  }
</style>
